/**
 * Normalizzazione dei codici chip.
 *
 * Un codice chip viene salvato in archivio **sempre normalizzato**: maiuscolo,
 * solo lettere e cifre. È la forma con cui viene confrontato, cercato e reso
 * univoco dentro un evento.
 *
 * Conseguenza voluta: `ab-12 34`, `AB1234` e `A B 1 2 3 4` sono lo stesso chip.
 * Va bene perché i codici dei transponder sono alfanumerici: spazi e simboli
 * sono sempre rumore introdotto dal file di import o dal lettore barcode.
 */
export function normalizeChipCode(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/** Lunghezza massima accettata per un codice chip (dopo normalizzazione). */
export const MAX_CHIP_CODE_LENGTH = 64;

/**
 * Normalizza un codice e verifica che sia utilizzabile.
 * Restituisce `null` se dopo la normalizzazione non resta nulla.
 */
export function parseChipCode(raw: string): string | null {
  const code = normalizeChipCode(raw);
  if (code.length === 0 || code.length > MAX_CHIP_CODE_LENGTH) return null;
  return code;
}
